import ApplicationSerializer from 'eflex/serializers/application';

export default class HardwareInputDefConfigSerializer extends ApplicationSerializer {
  attrs = {
    taskConfig: {
      serialize: false,
      deserialize: false,
    },
  };
}
